import { calculateMaxSpecialTrainLevel } from "./calculateMaxTrainLevel";

const positionC = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 3 },
    11: { s1: 3, s2: 2, s3: 1, s4: 2, s5: 2, s6: 3 },
    12: { s1: 3, s2: 2, s3: 2, s4: 3, s5: 2, s6: 3 },
    13: { s1: 3, s2: 2, s3: 2, s4: 3, s5: 2, s6: 5 },
    14: { s1: 3, s2: 3, s3: 2, s4: 4, s5: 2, s6: 5 },
    15: { s1: 4, s2: 4, s3: 2, s4: 4, s5: 2, s6: 5 },
    16: { s1: 4, s2: 4, s3: 3, s4: 4, s5: 3, s6: 6 },
    17: { s1: 4, s2: 5, s3: 3, s4: 6, s5: 3, s6: 6 },
    18: { s1: 5, s2: 6, s3: 3, s4: 6, s5: 3, s6: 7 },
    19: { s1: 5, s2: 6, s3: 4, s4: 7, s5: 3, s6: 8 },
    20: { s1: 7, s2: 6, s3: 4, s4: 7, s5: 4, s6: 8 }
};

const position1B = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    12: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 2, s6: 2 },
    13: { s1: 4, s2: 3, s3: 3, s4: 2, s5: 2, s6: 3 },
    14: { s1: 4, s2: 3, s3: 3, s4: 4, s5: 2, s6: 3 },
    15: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 2, s6: 3 },
    16: { s1: 4, s2: 5, s3: 5, s4: 4, s5: 3, s6: 3 },
    17: { s1: 5, s2: 6, s3: 5, s4: 5, s5: 3, s6: 3 },
    18: { s1: 6, s2: 6, s3: 6, s4: 5, s5: 3, s6: 4 },
    19: { s1: 6, s2: 7, s3: 7, s4: 6, s5: 3, s6: 4 },
    20: { s1: 8, s2: 7, s3: 7, s4: 6, s5: 4, s6: 4 }
};

const position2B_SS = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 1, s4: 3, s5: 1, s6: 2 },
    11: { s1: 2, s2: 2, s3: 2, s4: 3, s5: 2, s6: 2 },
    12: { s1: 2, s3: 3, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 3 },
    14: { s1: 2, s2: 3, s3: 3, s4: 4, s5: 3, s6: 4 },
    15: { s1: 3, s2: 4, s3: 3, s4: 4, s5: 3, s6: 4 },
    16: { s1: 3, s2: 4, s3: 5, s4: 4, s5: 4, s6: 4 },
    17: { s1: 3, s2: 5, s3: 5, s4: 6, s5: 4, s6: 4 },
    18: { s1: 4, s2: 5, s3: 5, s4: 6, s5: 5, s6: 5 },
    19: { s1: 4, s2: 5, s3: 6, s4: 7, s5: 5, s6: 5 },
    20: { s1: 5, s2: 6, s3: 6, s4: 7, s5: 6, s6: 6 }
};

const position3B = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 },
    12: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 2, s6: 2 },
    13: { s1: 4, s2: 3, s3: 3, s4: 2, s5: 2, s6: 3 },
    14: { s1: 4, s2: 3, s3: 3, s4: 4, s5: 2, s6: 3 },
    15: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 2, s6: 3 },
    16: { s1: 4, s2: 5, s3: 5, s4: 4, s5: 3, s6: 3 },
    17: { s1: 5, s2: 6, s3: 5, s4: 5, s5: 3, s6: 3 },
    18: { s1: 6, s2: 6, s3: 6, s4: 5, s5: 3, s6: 4 },
    19: { s1: 6, s2: 7, s3: 7, s4: 6, s5: 3, s6: 4 },
    20: { s1: 8, s2: 7, s3: 7, s4: 6, s5: 4, s6: 4 }
};

const positionLF = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 3, s2: 2, s3: 1, s4: 2, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 1, s4: 3, s5: 2, s6: 2 },
    12: { s1: 3, s2: 2, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 },
    14: { s1: 3, s2: 3, s3: 3, s4: 4, s5: 2, s6: 4 },
    15: { s1: 3, s2: 4, s3: 3, s4: 4, s5: 3, s6: 4 },
    16: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 4, s6: 4 },
    17: { s1: 4, s2: 5, s3: 5, s4: 5, s5: 4, s6: 4 },
    18: { s1: 5, s2: 5, s3: 5, s4: 6, s5: 4, s6: 5 },
    19: { s1: 5, s2: 6, s3: 6, s4: 7, s5: 4, s6: 5 },
    20: { s1: 7, s2: 6, s3: 6, s4: 7, s5: 5, s6: 5 }
};

const positionCF = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 3 },
    11: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 3, s6: 3 },
    12: { s1: 2, s2: 2, s3: 3, s4: 2, s5: 3, s6: 3 },
    13: { s1: 2, s2: 2, s3: 3, s4: 2, s5: 3, s6: 5 },
    14: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 5 },
    15: { s1: 2, s2: 4, s3: 3, s4: 3, s5: 4, s6: 5 },
    16: { s1: 2, s2: 4, s3: 5, s4: 3, s5: 5, s6: 5 },
    17: { s1: 2, s2: 5, s3: 5, s4: 4, s5: 5, s6: 6 },
    18: { s1: 3, s2: 5, s3: 5, s4: 4, s5: 6, s6: 7 },
    19: { s1: 3, s2: 6, s3: 6, s4: 5, s5: 6, s6: 7 },
    20: { s1: 4, s2: 6, s3: 6, s4: 5, s5: 7, s6: 8 }
};

const positionRF = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 },
    4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 },
    8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 2, s6: 3 },
    12: { s1: 2, s2: 3, s3: 3, s4: 2, s5: 2, s6: 3 },
    13: { s1: 2, s2: 3, s3: 3, s4: 2, s5: 3, s6: 4 },
    14: { s1: 2, s2: 3, s3: 4, s4: 3, s5: 3, s6: 4 },
    15: { s1: 3, s2: 4, s3: 4, s4: 3, s5: 3, s6: 4 },
    16: { s1: 3, s2: 4, s3: 5, s4: 3, s5: 4, s6: 5 },
    17: { s1: 3, s2: 5, s3: 5, s4: 4, s5: 5, s6: 5 },
    18: { s1: 4, s2: 6, s3: 5, s4: 4, s5: 5, s6: 6 },
    19: { s1: 4, s2: 6, s3: 6, s4: 5, s5: 5, s6: 6 },
    20: { s1: 5, s2: 6, s3: 7, s4: 5, s5: 6, s6: 7 }
};

const positionDH = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 3, s3: 1, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 1, s4: 3, s5: 2, s6: 2 }, 12: { s1: 3, s2: 3, s3: 2, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 4, s3: 3, s4: 4, s5: 2, s6: 3 },
    15: { s1: 4, s2: 5, s3: 3, s4: 4, s5: 2, s6: 3 }, 16: { s1: 4, s2: 5, s3: 5, s4: 4, s5: 3, s6: 3 },
    17: { s1: 4, s2: 6, s3: 5, s4: 6, s5: 3, s6: 3 }, 18: { s1: 5, s2: 7, s3: 5, s4: 6, s5: 3, s6: 4 },
    19: { s1: 5, s2: 7, s3: 7, s4: 7, s5: 3, s6: 4 }, 20: { s1: 7, s2: 7, s3: 7, s4: 7, s5: 4, s6: 4 }
};

const positionSUB1 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 3, s3: 1, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 1, s4: 3, s5: 2, s6: 2 }, 12: { s1: 3, s2: 3, s3: 2, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 4, s3: 2, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 4, s3: 3, s4: 4, s5: 2, s6: 3 },
    15: { s1: 3, s2: 5, s3: 3, s4: 5, s5: 2, s6: 3 }, 16: { s1: 3, s2: 6, s3: 4, s4: 5, s5: 3, s6: 3 },
    17: { s1: 4, s2: 7, s3: 4, s4: 6, s5: 3, s6: 3 }, 18: { s1: 5, s2: 7, s3: 4, s4: 7, s5: 3, s6: 4 },
    19: { s1: 5, s2: 8, s3: 5, s4: 8, s5: 3, s6: 4 }, 20: { s1: 6, s2: 8, s3: 6, s4: 8, s5: 4, s6: 4 }
};

const positionSUB2 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 3, s2: 2, s3: 1, s4: 2, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 }, 12: { s1: 3, s2: 2, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 4, s2: 3, s3: 3, s4: 4, s5: 2, s6: 3 },
    15: { s1: 4, s2: 5, s3: 3, s4: 4, s5: 2, s6: 3 }, 16: { s1: 4, s2: 5, s3: 5, s4: 4, s5: 3, s6: 3 },
    17: { s1: 5, s2: 6, s3: 5, s4: 5, s5: 3, s6: 3 }, 18: { s1: 6, s2: 6, s3: 5, s4: 6, s5: 3, s6: 4 },
    19: { s1: 6, s2: 7, s3: 6, s4: 7, s5: 3, s6: 4 }, 20: { s1: 8, s2: 7, s3: 6, s4: 7, s5: 4, s6: 4 }
};

const positionSUB3 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 2, s4: 2, s5: 2, s6: 2 }, 12: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 2 },
    13: { s1: 2, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 }, 14: { s1: 2, s2: 3, s3: 4, s4: 5, s5: 3, s6: 3 },
    15: { s1: 2, s2: 5, s3: 4, s4: 5, s5: 3, s6: 3 }, 16: { s1: 2, s2: 5, s3: 5, s4: 5, s5: 4, s6: 4 },
    17: { s1: 2, s2: 6, s3: 5, s4: 7, s5: 4, s6: 4 }, 18: { s1: 3, s2: 6, s3: 5, s4: 7, s5: 5, s6: 5 },
    19: { s1: 3, s2: 7, s3: 6, s4: 8, s5: 5, s6: 5 }, 20: { s1: 4, s2: 7, s3: 7, s4: 8, s5: 6, s6: 5 }
};

const positionSUB4 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 2, s6: 2 },
    11: { s1: 2, s2: 2, s3: 1, s4: 3, s5: 3, s6: 2 }, 12: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 3, s6: 2 },
    13: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 3, s6: 4 }, 14: { s1: 2, s2: 3, s3: 2, s4: 4, s5: 4, s6: 4 },
    15: { s1: 2, s2: 4, s3: 3, s4: 4, s5: 4, s6: 4 }, 16: { s1: 2, s2: 5, s3: 4, s4: 4, s5: 5, s6: 4 },
    17: { s1: 2, s2: 6, s3: 4, s4: 5, s5: 6, s6: 4 }, 18: { s1: 3, s2: 6, s3: 4, s4: 6, s5: 6, s6: 5 },
    19: { s1: 3, s2: 6, s3: 5, s4: 7, s5: 6, s6: 5 }, 20: { s1: 4, s2: 6, s3: 5, s4: 7, s5: 8, s6: 6 }
};

const positionSUB5 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 3 },
    11: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 3, s6: 3 }, 12: { s1: 2, s2: 2, s3: 3, s4: 2, s5: 3, s6: 3 },
    13: { s1: 2, s2: 3, s3: 3, s4: 2, s5: 3, s6: 4 }, 14: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 5 },
    15: { s1: 2, s2: 4, s3: 3, s4: 3, s5: 4, s6: 5 }, 16: { s1: 2, s2: 4, s3: 4, s4: 4, s5: 5, s6: 5 },
    17: { s1: 2, s2: 5, s3: 4, s4: 5, s5: 5, s6: 5 }, 18: { s1: 3, s2: 6, s3: 4, s4: 5, s5: 5, s6: 6 },
    19: { s1: 3, s2: 6, s3: 5, s4: 6, s5: 5, s6: 7 }, 20: { s1: 4, s2: 6, s3: 5, s4: 6, s5: 7, s6: 8 }
};

const positionSUB6 = {
    1: { s1: 0, s2: 1, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 0 },
    3: { s1: 0, s2: 1, s3: 0, s4: 1, s5: 0, s6: 1 }, 4: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 0, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 1, s4: 2, s5: 1, s6: 1 }, 8: { s1: 1, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 },
    9: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 1 }, 10: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 1, s6: 3 },
    11: { s1: 2, s2: 2, s3: 1, s4: 2, s5: 3, s6: 3 }, 12: { s1: 2, s2: 2, s3: 3, s4: 2, s5: 3, s6: 3 },
    13: { s1: 2, s2: 3, s3: 3, s4: 2, s5: 3, s6: 4 }, 14: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 5 },
    15: { s1: 2, s2: 4, s3: 3, s4: 3, s5: 4, s6: 5 }, 16: { s1: 2, s2: 4, s3: 4, s4: 4, s5: 5, s6: 5 },
    17: { s1: 2, s2: 5, s3: 4, s4: 5, s5: 5, s6: 5 }, 18: { s1: 3, s2: 6, s3: 4, s4: 5, s5: 5, s6: 6 },
    19: { s1: 3, s2: 6, s3: 5, s4: 6, s5: 5, s6: 7 }, 20: { s1: 4, s2: 6, s3: 5, s4: 6, s5: 7, s6: 8 }
};

const positionCP = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 3, s2: 2, s3: 2, s4: 1, s5: 1, s6: 2 },
    11: { s1: 3, s2: 3, s3: 2, s4: 1, s5: 2, s6: 2 }, 12: { s1: 3, s2: 3, s3: 2, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 4, s2: 3, s3: 4, s4: 3, s5: 2, s6: 3 },
    15: { s1: 5, s2: 4, s3: 4, s4: 3, s5: 2, s6: 3 }, 16: { s1: 5, s2: 4, s3: 4, s4: 5, s5: 3, s6: 3 },
    17: { s1: 6, s2: 4, s3: 6, s4: 5, s5: 3, s6: 3 }, 18: { s1: 6, s2: 5, s3: 7, s4: 5, s5: 3, s6: 4 },
    19: { s1: 7, s2: 5, s3: 8, s4: 6, s5: 3, s6: 4 }, 20: { s1: 7, s2: 7, s3: 8, s4: 6, s5: 4, s6: 4 }
};

const positionRP1 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 3, s4: 1, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 3, s4: 1, s5: 2, s6: 2 }, 12: { s1: 3, s2: 2, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s3: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 3, s3: 5, s4: 3, s5: 2, s6: 3 },
    15: { s1: 4, s2: 3, s3: 5, s4: 3, s5: 3, s6: 3 }, 16: { s1: 5, s2: 3, s3: 5, s4: 4, s5: 4, s6: 3 },
    17: { s1: 6, s2: 3, s3: 6, s4: 5, s5: 4, s6: 3 }, 18: { s1: 6, s2: 4, s3: 7, s4: 5, s5: 4, s6: 4 },
    19: { s1: 7, s2: 4, s3: 8, s4: 6, s5: 4, s6: 4 }, 20: { s1: 7, s2: 6, s3: 8, s4: 6, s5: 5, s6: 4 }
};

const positionRP2 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 3, s4: 1, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 3, s4: 1, s5: 2, s6: 2 }, 12: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 3, s3: 4, s4: 3, s5: 2, s6: 4 },
    15: { s1: 4, s2: 4, s3: 4, s4: 3, s5: 2, s6: 4 }, 16: { s1: 4, s2: 4, s3: 5, s4: 4, s5: 3, s6: 4 },
    17: { s1: 6, s2: 4, s3: 6, s4: 4, s5: 3, s6: 4 }, 18: { s1: 6, s2: 5, s3: 6, s4: 5, s5: 3, s6: 5 },
    19: { s1: 6, s2: 6, s3: 7, s4: 6, s5: 3, s6: 5 }, 20: { s1: 7, s2: 7, s3: 7, s4: 6, s5: 4, s6: 5 }
};

const positionRP3 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 3, s6: 2 }, 12: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 3, s6: 2 },
    13: { s1: 3, s2: 3, s3: 2, s4: 3, s5: 3, s6: 3 }, 14: { s1: 3, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 },
    15: { s1: 4, s2: 3, s3: 4, s4: 4, s5: 3, s6: 3 }, 16: { s1: 4, s2: 4, s3: 4, s4: 5, s5: 4, s6: 3 },
    17: { s1: 6, s2: 4, s3: 5, s4: 5, s5: 4, s6: 3 }, 18: { s1: 6, s2: 5, s3: 5, s4: 5, s5: 5, s6: 4 },
    19: { s1: 6, s2: 5, s3: 7, s4: 6, s5: 5, s6: 4 }, 20: { s1: 6, s2: 7, s3: 7, s4: 6, s5: 6, s6: 4 }
};

const positionRP4 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 3, s2: 2, s3: 2, s4: 1, s5: 1, s6: 2 },
    11: { s1: 3, s2: 2, s3: 2, s4: 2, s5: 2, s6: 2 }, 12: { s1: 3, s2: 2, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 },
    15: { s1: 4, s2: 3, s3: 5, s4: 3, s5: 3, s6: 3 }, 16: { s1: 4, s2: 3, s3: 5, s4: 5, s5: 4, s6: 3 },
    17: { s1: 6, s2: 3, s3: 6, s4: 5, s5: 4, s6: 3 }, 18: { s1: 6, s2: 5, s3: 6, s4: 5, s5: 4, s6: 4 },
    19: { s1: 6, s2: 5, s3: 7, s4: 7, s5: 4, s6: 4 }, 20: { s1: 6, s2: 6, s3: 8, s4: 7, s5: 5, s6: 4 }
};

// RP5 & RP6 - 두 포지션의 상승 테이블이 동일합니다.
const positionRP5_RP6 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 2, s4: 1, s5: 2, s6: 2 },
    11: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 3, s6: 2 }, 12: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 3, s6: 2 },
    13: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 3 }, 14: { s1: 3, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 },
    15: { s1: 4, s2: 3, s3: 4, s4: 3, s5: 4, s6: 3 }, 16: { s1: 4, s2: 3, s3: 4, s4: 5, s5: 5, s6: 3 },
    17: { s1: 5, s2: 3, s3: 5, s4: 5, s5: 5, s6: 4 }, 18: { s1: 5, s2: 5, s3: 5, s4: 5, s5: 5, s6: 5 },
    19: { s1: 5, s2: 5, s3: 6, s4: 6, s5: 6, s6: 5 }, 20: { s1: 5, s2: 6, s3: 7, s4: 6, s5: 7, s6: 5 }
};

const positionSP1 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 3, s4: 1, s5: 1, s6: 2 },
    11: { s1: 2, s2: 2, s3: 3, s4: 1, s5: 3, s6: 2 }, 12: { s1: 3, s2: 2, s3: 3, s4: 2, s5: 3, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 2, s5: 3, s6: 3 }, 14: { s1: 3, s2: 3, s3: 5, s4: 2, s5: 3, s6: 3 },
    15: { s1: 4, s2: 3, s3: 5, s4: 3, s5: 3, s6: 3 }, 16: { s1: 4, s2: 3, s3: 5, s4: 4, s5: 5, s6: 3 },
    17: { s1: 6, s2: 3, s3: 6, s4: 4, s5: 5, s6: 3 }, 18: { s1: 6, s2: 5, s3: 6, s4: 4, s5: 5, s6: 4 },
    19: { s1: 6, s2: 5, s3: 8, s4: 5, s5: 5, s6: 4 }, 20: { s1: 6, s2: 6, s3: 8, s4: 6, s5: 6, s6: 4 }
};

const positionSP2 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
    2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 },
    4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 },
    6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 },
    10: { s1: 2, s2: 2, s3: 2, s4: 1, s5: 2, s6: 2 },
    11: { s1: 3, s2: 2, s3: 2, s4: 1, s5: 3, s6: 2 },
    12: { s1: 3, s2: 3, s3: 2, s4: 2, s5: 3, s6: 2 },
    13: { s1: 3, s2: 3, s3: 2, s4: 3, s5: 3, s6: 3 },
    14: { s1: 4, s2: 3, s3: 3, s4: 3, s5: 3, s6: 3 },
    15: { s1: 5, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 },
    16: { s1: 5, s2: 3, s3: 4, s4: 4, s5: 5, s6: 3 },
    17: { s1: 6, s2: 4, s3: 5, s4: 4, s5: 5, s6: 3 },
    18: { s1: 7, s2: 5, s3: 5, s4: 4, s5: 5, s6: 4 },
    19: { s1: 7, s2: 5, s3: 6, s4: 6, s5: 5, s6: 4 },
    20: { s1: 7, s2: 6, s3: 7, s4: 6, s5: 6, s6: 4 }
};

const positionSP3 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 3, s3: 2, s4: 1, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 3, s4: 1, s5: 2, s6: 2 }, 12: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 3 }, 14: { s1: 3, s2: 3, s3: 4, s4: 3, s5: 3, s6: 3 },
    15: { s1: 4, s2: 3, s3: 4, s4: 4, s5: 3, s6: 3 }, 16: { s1: 4, s2: 4, s3: 4, s4: 5, s5: 4, s6: 3 },
    17: { s1: 5, s2: 4, s3: 6, s4: 5, s5: 4, s6: 3 }, 18: { s1: 6, s2: 5, s3: 6, s4: 5, s5: 4, s6: 4 },
    19: { s1: 6, s2: 5, s3: 7, s4: 6, s5: 5, s6: 4 }, 20: { s1: 6, s2: 6, s3: 7, s4: 7, s5: 6, s6: 4 }
};

const positionSP4 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 2, s4: 1, s5: 2, s6: 2 },
    11: { s1: 2, s2: 3, s3: 2, s4: 1, s5: 3, s6: 2 }, 12: { s1: 2, s2: 3, s3: 2, s4: 3, s5: 3, s6: 2 },
    13: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 3, s6: 3 }, 14: { s1: 2, s2: 3, s3: 4, s4: 3, s5: 4, s6: 3 },
    15: { s1: 4, s2: 3, s3: 4, s4: 3, s5: 4, s6: 3 }, 16: { s1: 4, s2: 4, s3: 4, s4: 4, s5: 5, s6: 3 },
    17: { s1: 5, s2: 4, s3: 5, s4: 5, s5: 5, s6: 3 }, 18: { s1: 5, s2: 5, s3: 5, s4: 5, s5: 6, s4: 4 },
    19: { s1: 5, s2: 5, s3: 7, s4: 6, s5: 6, s6: 4 }, 20: { s1: 6, s2: 6, s3: 7, s4: 6, s5: 7, s6: 4 }
};

const positionSP5 = {
    1: { s1: 1, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 }, 2: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 0 },
    3: { s1: 1, s2: 0, s3: 1, s4: 0, s5: 0, s6: 1 }, 4: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 0, s6: 1 },
    5: { s1: 1, s2: 0, s3: 1, s4: 1, s5: 1, s6: 1 }, 6: { s1: 1, s2: 1, s3: 1, s4: 1, s5: 1, s6: 1 },
    7: { s1: 1, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 }, 8: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 1 },
    9: { s1: 2, s2: 1, s3: 2, s4: 1, s5: 1, s6: 2 }, 10: { s1: 2, s2: 2, s3: 2, s4: 2, s5: 1, s6: 2 },
    11: { s1: 2, s2: 3, s3: 2, s4: 2, s5: 2, s6: 2 }, 12: { s1: 2, s2: 3, s3: 3, s4: 3, s5: 2, s6: 2 },
    13: { s1: 3, s2: 3, s3: 3, s4: 3, s5: 2, s6: 3 }, 14: { s1: 3, s2: 4, s3: 4, s4: 3, s5: 2, s6: 3 },
    15: { s1: 4, s2: 4, s3: 4, s4: 3, s5: 3, s6: 3 }, 16: { s1: 4, s2: 4, s3: 4, s4: 5, s5: 4, s6: 3 },
    17: { s1: 5, s2: 4, s3: 6, s4: 5, s5: 4, s6: 3 }, 18: { s1: 5, s2: 6, s3: 6, s4: 5, s5: 4, s6: 4 },
    19: { s1: 6, s2: 6, s3: 7, s4: 6, s5: 4, s6: 4 }, 20: { s1: 6, s2: 7, s3: 7, s4: 6, s5: 6, s6: 4 }
};

const positionTrainMap = {
    'C': positionC,
    '1B': position1B,
    '2B': position2B_SS,
    '3B': position3B,
    'SS': position2B_SS,
    'LF': positionLF,
    'CF': positionCF,
    'RF': positionRF,
    'DH': positionDH,
    'SUB1': positionSUB1,
    'SUB2': positionSUB2,
    'SUB3': positionSUB3,
    'SUB4': positionSUB4,
    'SUB5': positionSUB5,
    'SUB6': positionSUB6,
    'CP': positionCP,
    'RP1': positionRP1,
    'RP2': positionRP2,
    'RP3': positionRP3,
    'RP4': positionRP4,
    'RP5': positionRP5_RP6,
    'RP6': positionRP5_RP6,
    'SP1': positionSP1,
    'SP2': positionSP2,
    'SP3': positionSP3,
    'SP4': positionSP4,
    'SP5': positionSP5
};

const level0 = { s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 };

export function calculatePositionTrainStates(player, level, position) {

    if (level <= 0) {
        return level0;
    } else {
        return positionTrainMap[position][level] || level0;
    }
}
export function getPositionTrainAdditionalStatesText(player) {
    const stateKeys = ['s1', 's2', 's3', 's4', 's5', 's6'];
    const stateLabelMap = player.isPitcher ? 
        {'s1': '구속', 's2': "변화", 's3': "구위", 's4': "제구", 's5': "지구력", 's6': "수비"}
        :
        {'s1': '파워', 's2': "정확", 's3': "선구", 's4': "인내", 's5': "주루", 's6': "수비"};

    const MAX_INCREASE = 3; 
    let resultString = '';
    
    let usedSlotsCount = 0; 
    
    for (const key of stateKeys) {
        let value = player.positionTrainedAdditionalStates[key] || 0;
        const label = stateLabelMap[key];
        
        if (value === 0) {
            continue;
        }

        while (value > 0) {
            const currentIncrease = Math.min(value, MAX_INCREASE);
            
            resultString += ` + ${currentIncrease}/${MAX_INCREASE}(${label})`;
            
            usedSlotsCount++; 
            
            value -= currentIncrease;
        }
    }

        const currentLevel = player.positionTrainedStates.level || 0; 

    const numSlots = currentLevel >= 15 ? 2 : (currentLevel >= 5 ? 1 : 0);

    const emptySlots = numSlots - usedSlotsCount;

    for (let i = 0; i < emptySlots; i++) {
        resultString += ` + 0/${MAX_INCREASE}`; 
    }

    return resultString;
}

export function getMaxPositionTrainStates(player, position) {
    const maxPositionTrainStates = positionTrainMap[position][20];

    return {level:20, ...maxPositionTrainStates};
}

export function getMaxPositionTrainAdditionalStates(player, position) {
    const pitcherAdditionalStates = {s1:0, s2:6, s3:0, s4:0, s5:0, s6:0};
    const batterAdditionalStates = {s1:6, s2:0, s3:0, s4:0, s5:0, s6:0};

    return player.isPitcher ? pitcherAdditionalStates : batterAdditionalStates;
}

export function getMaxSpecialTrainStates(player) {

    const maxSpecialTrainStatesBatter3 = {level: 3, s1:3, s2:0, s3:0, s4:0, s5:0, s6:0};
    const maxSpecialTrainStatesPitcher3 = {level: 3, s1:0, s2:3, s3:0, s4:0, s5:0, s6:0};
    
    const maxSpecialTrainStatesBatter4 = {level: 4, s1:4, s2:0, s3:0, s4:0, s5:0, s6:0};
    const maxSpecialTrainStatesPitcher4 = {level: 4, s1:0, s2:4, s3:0, s4:0, s5:0, s6:0};

    const maxSpecialTrainStatesBatter5 = {level: 5, s1:5, s2:0, s3:0, s4:0, s5:0, s6:0};
    const maxSpecialTrainStatesPitcher5 = {level: 5, s1:0, s2:5, s3:0, s4:0, s5:0, s6:0};

    const zeroSpecialTrainStates = {level: 0, s1:0, s2:0, s3:0, s4:0, s5:0, s6:0};

    const maxSpecialTrainLevel = calculateMaxSpecialTrainLevel(player)

    const maxSpecialTrainStatesBatter = {
        3 : maxSpecialTrainStatesBatter3,
        4 : maxSpecialTrainStatesBatter4,
        5 : maxSpecialTrainStatesBatter5,
        0 : zeroSpecialTrainStates
    }

    const maxSpecialTrainStatesPitcher = {
        3 : maxSpecialTrainStatesPitcher3,
        4 : maxSpecialTrainStatesPitcher4,
        5 : maxSpecialTrainStatesPitcher5,
        0 : zeroSpecialTrainStates
    }


    const isSpecialTrainAvailableTypes = ['임팩트', '시그니쳐', '국가대표', '골든글러브', '올스타'];
    
    if(isSpecialTrainAvailableTypes.includes(player.type)) { 
        return player.isPitcher ? maxSpecialTrainStatesPitcher[maxSpecialTrainLevel] : maxSpecialTrainStatesBatter[maxSpecialTrainLevel];
    } else {
        return zeroSpecialTrainStates
    }
}